import script from "./LazyImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LazyImage.vue?vue&type=script&setup=true&lang=ts"

import "./LazyImage.vue?vue&type=style&index=0&id=20b0d360&lang=scss&scoped=true"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20b0d360"]])

export default __exports__